import { render, staticRenderFns } from "./MiniButtonFull.vue?vue&type=template&id=581b4cd3&scoped=true&"
import script from "./MiniButtonFull.vue?vue&type=script&lang=js&"
export * from "./MiniButtonFull.vue?vue&type=script&lang=js&"
import style0 from "./MiniButtonFull.vue?vue&type=style&index=0&id=581b4cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b4cd3",
  null
  
)

export default component.exports